module.exports = __webpack_public_path__ + "img/email.5cc7e840.svg";